import { Component, OnInit } from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../shared/rest/rest.service';
import {AlertService} from '../shared/alert.service';
import {CustomValidators} from '../shared/custom-validators';
import {LevenshteinValidatorService} from "../shared/levenshtein-validator.service";

@Component({
  selector: 'app-password-expired',
  templateUrl: './password-expired.component.html',
  styleUrls: ['./password-expired.component.scss']
})
export class PasswordExpiredComponent implements OnInit {

  inProgress = false;
  success = false;
  initialized = false;

  passwordExpiredForm;

  constructor(
      public router: Router,
      private activatedRoute: ActivatedRoute,
      private restService: RestService,
      private alertService: AlertService,
      private levenshteinValidator: LevenshteinValidatorService
  ) {
  }

  ngOnInit() {
    this.levenshteinValidator.initialized.subscribe(val => {

      if(val) {
        this.passwordExpiredForm = new FormGroup({
          passwordold: new FormControl('', [
            Validators.required]),
          password: new FormControl('', CustomValidators.passwordFieldValidators()),
          passwordconfirm: new FormControl('', [
            Validators.required])
        }, [CustomValidators.passwordMatchValidator, CustomValidators.passwordTheSameValidator, this.levenshteinValidator.passwordLevenshteinValidator]);

        this.initialized = true;
      }});
    this.levenshteinValidator.init();
  }

  submit(){
    if (this.passwordExpiredForm.valid) {
      this.inProgress = true;
      this.restService.updateExpiredPassword(
          this.passwordExpiredForm.value.passwordold,
          this.passwordExpiredForm.value.password,
          this.passwordExpiredForm.value.passwordconfirm)
          .subscribe(response => {
            this.success = true;
            this.alertService.success('passwordExpiredForm.success')
            this.router.navigate(['boslogin', 'logout']);
          }, error => {
            this.inProgress = false;
            this.success = false;
            this.restService.handleError(error)
            console.error(error);
          });
    }
  }

}
